import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'lib/core/data/reducer'
import { ProductAttributeItem, ProductAttributeList } from './types'

export const getProductAttributeList = createSelector(
  (state: RootState) => state.common.productAttributeList.payload,
  payload => {
    const index: ProductAttributeList = {}
    const items: ProductAttributeItem[] = payload?.items ?? []

    items.forEach(item => {
      const {
        attribute_code: attributeCode,
        default_frontend_label: defaultLabel,
        frontend_input: frontendInput,
        options: optionsList
      } = item

      const options = (optionsList ?? []).reduce((obj: Record<string, string>, option) => {
        const { label, value } = option
        obj[value] = label
        return obj
      }, {})

      index[attributeCode] = {
        defaultLabel,
        frontendInput,
        options
      }
    })

    return index
  }
)
